import { Link } from "react-router-dom";
import { Heart, Bookmark, MessageCircle, Clock, Boxes } from "lucide-react";
import { brl, DIFFICULTY, mediaUrl } from "@/lib/api";

export function ProjectCard({ project, index = 0 }) {
  const diff = DIFFICULTY[project.difficulty] || DIFFICULTY.facil;
  return (
    <Link
      to={`/projeto/${project.slug}`}
      data-testid={`project-card-${project.slug}`}
      className="group block overflow-hidden rounded-2xl border border-border bg-card hover-lift fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-secondary">
        <img
          src={mediaUrl(project.cover)}
          alt={project.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-semibold ${diff.color}`}>
          {diff.label}
        </span>
        {project.is_featured && (
          <span className="absolute right-3 top-3 rounded-full bg-accent px-2.5 py-1 text-xs font-bold text-accent-foreground">
            Destaque
          </span>
        )}
        <span className="absolute bottom-3 left-3 rounded-lg bg-black/55 px-2 py-1 text-xs font-semibold text-white backdrop-blur-sm">
          {brl(project.cost)}
        </span>
      </div>
      <div className="p-4">
        <p className="eyebrow text-primary">{project.category}</p>
        <h3 className="mt-1.5 line-clamp-2 text-base font-bold leading-snug">{project.title}</h3>
        <div className="mt-3 flex items-center gap-2">
          <img src={mediaUrl(project.author?.avatar)} alt="" className="h-6 w-6 rounded-full object-cover" />
          <span className="text-xs text-muted-foreground truncate">{project.author?.name}</span>
        </div>
        <div className="mt-3 flex items-center gap-4 border-t border-border pt-3 text-xs text-muted-foreground">
          <span className="flex items-center gap-1">
            <Heart className={`h-3.5 w-3.5 ${project.is_liked ? "fill-primary text-primary" : ""}`} /> {project.likes_count}
          </span>
          <span className="flex items-center gap-1">
            <Bookmark className={`h-3.5 w-3.5 ${project.is_favorited ? "fill-accent text-accent" : ""}`} /> {project.favorites_count}
          </span>
          <span className="flex items-center gap-1">
            <MessageCircle className="h-3.5 w-3.5" /> {project.comments_count}
          </span>
          <span className="ml-auto flex items-center gap-1">
            <Boxes className="h-3.5 w-3.5" /> {project.pallets_count}
          </span>
        </div>
      </div>
    </Link>
  );
}

export function ProjectCardSkeleton() {
  return (
    <div className="overflow-hidden rounded-2xl border border-border bg-card">
      <div className="aspect-[4/3] animate-pulse bg-secondary" />
      <div className="space-y-2 p-4">
        <div className="h-3 w-20 animate-pulse rounded bg-secondary" />
        <div className="h-4 w-full animate-pulse rounded bg-secondary" />
        <div className="h-4 w-2/3 animate-pulse rounded bg-secondary" />
      </div>
    </div>
  );
}
